import React from 'react';

import { Button as MuiButton } from 'components/Button';
import { AIIcon } from 'containers/Tiptap/components/tiptap-icons/ai-icon';

import { colors } from 'theme/colors';
import { StyledTextField } from 'components/Input/styles';

import { StyledAiPendingHint } from './styles';

interface AIInputSectionProps {
  aiInput: string;
  setAiInput: (value: string) => void;
  onGenerate: () => void;
  isGenerating: boolean;
  hasPending: boolean;
}

const AIInputSection: React.FC<AIInputSectionProps> = ({
  aiInput,
  setAiInput,
  onGenerate,
  isGenerating,
  hasPending,
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      width: '440px',
    }}
  >
    {hasPending && (
      <StyledAiPendingHint>Your previous AI suggestion will be kept when you generate again.</StyledAiPendingHint>
    )}
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '4px',
        alignItems: 'center',
      }}
    >
      <StyledTextField
        autoFocus
        value={aiInput}
        placeholder="Write your prompt here..."
        onChange={(e) => setAiInput(e.target.value)}
        multiline
        fullWidth
        onKeyDown={(e) => {
          // when clicking enter and shift, add a new line
          if (e.key === 'Enter' && e.shiftKey) {
            e.preventDefault();
            setAiInput(`${aiInput}\n`);
          } else if (e.key === 'Enter') {
            onGenerate();
          }
        }}
      />

      <MuiButton
        onClick={onGenerate}
        startIcon={<AIIcon color={colors.common.white} />}
        disabled={isGenerating || !aiInput.trim()}
        size="large"
        sx={{
          background: 'linear-gradient(126deg, #6340FF 9.22%, #EF4BFE 94.35%, #87ABFF 140.55%)',
          '& .MuiButton-startIcon': {
            color: colors.common.white,
          },
          '&:not(:disabled).MuiButton-textPrimary': {
            color: colors.common.white,
          },
          '&:disabled': {
            background: colors.grey[700],
            color: `${colors.common.white} !important`,
          },
          '&:hover.MuiButton-textPrimary': {
            background:
              'linear-gradient(126deg,rgb(62, 19, 253) 9.22%,rgb(236, 30, 255) 94.35%,rgb(45, 108, 255) 140.55%)',
          },
        }}
      >
        Generate
      </MuiButton>
    </div>
  </div>
);

export default AIInputSection;
